<template>
  <div v-if="notice" class="alert alert-warning">
    <p>{{ notice.text }}</p>
  </div>
</template>
<script>
export default {
  props: ['noticeKey'],
  data() {
    return {
      notice: null,
    };
  },
  mounted() {
    this.getSystemNotification();
  },
  methods: {
    getSystemNotification() {
      this.$store.dispatch('systemNotifications/getSystemNotification', this.noticeKey)
        .then((notice) => {
          this.notice = notice;
        }).catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
